import { clsx } from 'clsx';
import moment from 'moment/moment';
import { strapiApiUrlImage } from 'src/config';
import { ElipsIcon } from '../../../assets/new/icons';
import type { Article } from '../../../types/article';
import { getInitials } from '../../../utils/string';
import { ArticleTagsBlock } from './tag';

type Options = {
  className?: string;
  article: Pick<Article, 'author' | 'author_image' | 'publishedAt' | 'tags'>;
};

export default function ArticleMeta({ article, className }: Options) {
  return (
    <div
      className={clsx(
        'flex items-center justify-start max-sm:flex-row-reverse max-sm:justify-end max-sm:gap-2',
        className
      )}
    >
      <div className="flex items-center max-sm:hidden">
        <div className="mr-1 size-6 overflow-hidden rounded-3xl leading-none">
          {article.author_image.data?.attributes.url ? (
            <img
              src={`${strapiApiUrlImage}${article.author_image.data?.attributes.url}`}
              alt={article.author}
              className="h-full object-cover"
            />
          ) : (
            <div className="text-label-3-regular bg-green-100 text-center align-middle leading-6 text-neutral-600">
              {getInitials(article?.author)}
            </div>
          )}
        </div>
        <div className="text-label-2-medium text-neutral-600">
          {article.author}
        </div>
      </div>
      <ElipsIcon
        className="mx-2 fill-neutral-400 max-sm:hidden"
        width="0.25rem"
        height="0.25rem"
      />
      <div className="text-label-2-regular text-neutral-600">
        {moment(article.publishedAt).format('MMM. D, YYYY')}
      </div>
      {article.tags && (
        <ElipsIcon
          className="mx-2  fill-neutral-400 max-sm:hidden"
          width="0.25rem"
          height="0.25rem"
        />
      )}
      {article.tags && <ArticleTagsBlock tags={article.tags} />}
    </div>
  );
}
